import { useUser } from "@clerk/react";
import { useEffect } from "react";

import { AuthNotice } from "~/feature/auth/type";
import { consumeCampaignSignUpMark } from "~/feature/auth/utils/campaignSignUpMark";
import { isExistingAccountSignIn } from "~/feature/auth/utils/isExistingAccountSignIn";
import { showAuthNotice } from "~/feature/auth/utils/showAuthNotice";

export const useNewAccountsOnlyNotice = (): void => {
  const { user } = useUser();

  useEffect(() => {
    if (!user || !consumeCampaignSignUpMark()) {
      return;
    }

    if (isExistingAccountSignIn(user)) {
      showAuthNotice(AuthNotice.NewAccountsOnly);
    }
  }, [user]);
};
